import { lazy, Suspense, useEffect } from 'react';
import { useMoralis } from 'react-moralis';
import { Switch, Route } from 'react-router-dom';
import ChechChain from './CheckChain';

import Nav from './Nav';

const Aave = lazy(() => import('./Aave'));
const Profile = lazy(() => import('./Profile'));
const AavePool = lazy(() => import('./AavePool'));

const App = () => {
  const { isWeb3Enabled, enableWeb3, user } = useMoralis();

  useEffect(() => {
    if (user && !isWeb3Enabled) enableWeb3();
  }, [user, isWeb3Enabled, enableWeb3]);

  return (
    <>
      <div
        className='min-h-screen flex flex-col justify-center mx-auto px-6 2xl:px-0'
        style={{ maxWidth: '1400px' }}
      >
        <Nav />
        <div className='flex flex-col flex-1'>
          <Suspense fallback={<div></div>}>
            <Switch>
              <Route path='/profile'>
                <Profile />
              </Route>
              <Route path='/aave/:id'>
                <AavePool />
              </Route>
              <Route exact path='/'>
                <Aave />
              </Route>
            </Switch>
          </Suspense>
        </div>
      </div>
      <ChechChain />
    </>
  );
};

export default App;
